export default __webpack_public_path__ + "static/media/AXA-insurance-Logo.dafd1ed8.png";